"use client";
const e = Object.freeze({
  easeIn: "ease-in",
  easeOut: "ease-out"
}), s = Object.keys(e);
export {
  e as MOTION_EASINGS,
  s as MOTION_EASING_KEYS
};
